module.exports = __webpack_public_path__ + "dd1622f5ed11e5f08279b7b6adaf4cdd.pdf";